import styled from "styled-components";
import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import StyledButton from "./Button";
import EmptyImage from "./EmptyImage";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    border-radius: .5rem;
    border: 1px solid var(--color-lightGray);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    padding: 1rem 1.25rem;

    .thumbnail {
        aspect-ratio: 540/226;
        background: var(--color-xLightGray);
        border-radius: .5rem;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .cardContent {
        display: flex;
        flex-direction: column;
        gap: .5rem;
        flex: 1;
    }

    .cardContent > a {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;  
        overflow: hidden;
    }

    .cardContent > p {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;  
        overflow: hidden;
    }

    .promoTitle {
        font-size: var(--font-size-xxl);
        font-weight: var(--font-weight-bold);
        color: var(--color-black);
        text-decoration: none;
        font-family: var(--font-family);
    }

    .cardButtons {
        display: flex;
        align-items: center;
        gap: .5rem;

        p {
            flex: 1;
        }
    }
`;

const LuckyNumberPromoItem = ({data}) => {
    const linkToDetail = `/campanhas/${data.id}`;

    return (
        <Container>
            <div className="thumbnail">
                <Link to={linkToDetail}>
                    {data.promoThumbnailUrl && <img src={data.promoThumbnailUrl} alt={`Imagem ${data.name}`} />}
                    {!data.promoThumbnailUrl && <EmptyImage />}
                </Link>
            </div>
            <div className="cardContent">
                <Typography component={Link} variant='h5' to={linkToDetail} className='promoTitle'>{data.name}</Typography>
                <p>{data.description}</p>
            </div>
            <div className="cardButtons">
                <p>
                    {data.isEnded && <>Campanha encerrada</>}
                    {!data.isEnded && data.daysToParticipate && <>Faltam <strong>{data.daysToParticipate} dias</strong> para encerrar</>}
                </p>
                <StyledButton component={Link} to={linkToDetail} className="secondary small" style={{borderRadius: ".5rem"}}>
                    Saiba mais
                </StyledButton>
            </div>
        </Container>
    );
}

export default LuckyNumberPromoItem;